import { render } from "./NotifyOtherUsersOfSaveModal.vue?vue&type=template&id=12f4e210"
import script from "./NotifyOtherUsersOfSaveModal.vue?vue&type=script&lang=js"
export * from "./NotifyOtherUsersOfSaveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__